module.exports = __webpack_public_path__ + "img/info3.9cfdc807.png";